import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTimerIconSecondary from './svgs/TimerIconSecondary.js';
import SvgTimerIcon from './svgs/TimerIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var timerIcon = (props => useIcon(SvgTimerIcon, SvgTimerIconSecondary, props));

export { timerIcon as default };
